import * as React from 'react';
import 'intl-pluralrules';
import {AppRegistry} from 'react-native';
import App from './App';
import '../src/assets/fonts/fonts.css';

AppRegistry.registerComponent('App', () => App);
AppRegistry.runApplication('App', {
  rootTag: document.getElementById('root'),
});